import {
  IDynamicDiplayView,
  IDynamicSection
} from '@components/widgets/dynamic-display';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';

import { PolicyBankersDetails } from '../types';

export function buildPolicyBankersDetailsView(
  data: PolicyBankersDetails[],
  policyCurrencySymbol: string
): IDynamicDiplayView {
  return {
    name: 'PolicyBankersDetails',
    sections: data.map(
      (item, index) =>
        ({
          name: `PolicyBankersDetails${index}`,
          title: index === 0 ? 'Bankers Blanket Bond Details' : '',
          properties: {
            [`branchName${index}`]: {
              multiline: false,
              value: item.branchName,
              name: `branchName${index}`,
              title: 'Branch Name',
              tooltip: false
            },
            [`isMain${index}`]: {
              multiline: false,
              value: item.isMain ? 'Yes' : 'No',
              name: `isMain${index}`,
              title: 'Main',
              tooltip: false
            },
            [`isAgency${index}`]: {
              multiline: false,
              value: item.isAgency ? 'Yes' : 'No',
              name: `isAgency${index}`,
              title: 'Agency',
              tooltip: false
            },
            [`numberOfEmployees${index}`]: {
              multiline: false,
              value: item.employeeNumber,
              name: `numberOfEmployees${index}`,
              title: 'Employee Number',
              tooltip: false
            },
            [`underwritingYear${index}`]: {
              multiline: false,
              value: item.underwritingYear,
              name: `underwritingYear${index}`,
              title: 'Underwriting Year',
              tooltip: false
            },
            [`infidelity${index}`]: {
              multiline: false,
              value: item.infedility.toString(),
              name: `infidelity${index}`,
              title: 'Infidelity',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`burglary${index}`]: {
              multiline: false,
              value: item.burglary.toString(),
              name: `burglary${index}`,
              title: 'Burglary',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`holdUp${index}`]: {
              multiline: false,
              value: item.holdup.toString(),
              name: `holdUp${index}`,
              title: 'Hold Up',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`inSafe${index}`]: {
              multiline: false,
              value: item.inSafe.toString(),
              name: `inSafe${index}`,
              title: 'In Safe',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`inTransit${index}`]: {
              multiline: false,
              value: item.inTransit.toString(),
              name: `inTransit${index}`,
              title: 'In Transit',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`forgedChecks${index}`]: {
              multiline: false,
              value: item.forgedCheques.toString(),
              name: `forgedChecks${index}`,
              title: 'Forged Checks',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`counterfeitCurrencies${index}`]: {
              multiline: false,
              value: item.counterfeitCurrencies.toString(),
              name: `counterfeitCurrencies${index}`,
              title: 'Counterfeit Currencies',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`clause6${index}`]: {
              multiline: false,
              value: item.clause6.toString(),
              name: `clause6${index}`,
              title: 'Clause 6',
              tooltip: false,
              type: EnhancedDisplayType.RoundedCurrency,
              currencySymbol: policyCurrencySymbol
            },
            [`falsification${index}`]: {
              multiline: false,
              value: item.falsification.toString(),
              name: `falsification${index}`,
              type: EnhancedDisplayType.RoundedCurrency,
              title: 'Falsification',
              tooltip: false,
              currencySymbol: policyCurrencySymbol
            }
          }
        }) as IDynamicSection
    )
  };
}
